import { render, staticRenderFns } from "./PageletChart.vue?vue&type=template&id=4ea3d8cc&lang=pug"
import script from "./PageletChart.vue?vue&type=script&lang=js"
export * from "./PageletChart.vue?vue&type=script&lang=js"
import style0 from "./PageletChart.vue?vue&type=style&index=0&id=4ea3d8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
